module.exports = __webpack_public_path__ + "static/garden-8947af4fce3e4e45d57d505d8eeb830b.jpg";